const LoadingIndicator = () => null;

export default LoadingIndicator;
